import * as Cookie from 'tiny-cookie';
import _ from 'lodash';
import MggpLoader, { AD_GLOBAL_TIMEOUTS } from './index';
import utils from './utils';
import AdFoxLPD from './AdFoxLPD';

let _this = MggpLoader;

function init(self) {
  _this = self;
}

function onPlayerReady() {
  _this.player.load(
    _this.stream.src,
    _this.stream,
    utils.addAdditionalPlayerOptions(
      _this.config.checkDefaultOptions(),
      _this.stream,
      _this.storage,
      _this.player
    )
  );
}

function onPlayerStateChange(event) {
  if (event && event.data) {
    if (event.data === 1) {
      _this.errorRetrycount = 0;
      _this.errorRetryTimeout = 0;
      _this.contentBlockDetected = false;

      const skin = document.getElementById('playerContainer_skin');
      const adskin = document.getElementById('playerContainer_adskin');
      if (skin && skin.style.visibility === 'hidden') {
        // in _this case we know, that hidden was set by hideSkins event
        skin.style.visibility = 'visible';
      }
      if (adskin && adskin.style.visibility === 'hidden') {
        adskin.style.visibility = 'visible';
      }

      if (_this.lastPlayerState === 2) {
        const videoInfo = _this.player.get('videoInfo');
        if (videoInfo && videoInfo.is_tv === true) {
          _this.player.emit('epg:playerResume');
        }
      }

      const video = _this.player.getPlayableElement();
      if (video && video.style) {
        video.style.outline = 'initial';
      }
    }
    _this.lastPlayerState = event.data;
  }
  return false;
}

function onMessageModeChanged(e) {
  _this.messageMode = e.data;
}

function onPlayerComplete() {
  if (
    _this.stream &&
    _this.stream.next &&
    _this.stream.content_type === 'vod' &&
    _this.stream.next.toString().indexOf('i=0') === -1
  ) {
    _this.player.stop();
    setTimeout(function () {
      _this.player.emit('changeVideo', _this.stream.next);
    }, 100);
  } else if (
    _this.player.get('epg') ||
    _this.player.get('epg:currentChannel')
  ) {
    _this.player.stop();
    _this.player.set('state', 3);
  } else {
    _this.player.stop();
  }
}

function onAutoplayChanged(event) {
  if (_this.player.get('ignoreAutoplay')) {
    return;
  }
  if (
    event.data === true &&
    _.get(_this, 'stream.src') &&
    _this.player.get('state') !== 1
  ) {
    _this.stream = { ..._this.stream };
    _this.player.load(
      _this.stream.src,
      _this.stream,
      utils.addAdditionalPlayerOptions(
        _this.config.checkDefaultOptions(),
        _this.stream,
        _this.storage,
        _this.player
      )
    );
  }
}

function onQualityChange(event) {
  if (_this.player.get('duration') !== 0) {
    _this.storage.setQuality(event.data);
  }
}

function onAudioButtonClick() {
  // MHP-1743: проблема в том что property:audioTrack не отличает выбор аудио юзером от технического
  // переключения каким-то вендором/плагином и мы сторим значение хотя юзер ничего мог не делать.
  // Поскольку есть вероятность что аудио физически может не быть, приходится делать проверку :(

  const currentAudio = _this.player.get('audioTrack');
  setTimeout(() => {
    const newAudio = _this.player.get('audioTrack');
    if (newAudio !== currentAudio) {
      const videoId = _this.stream['root_video_id'] || _this.stream['video_id'];
      _this.storage.setAudioByVideoId(videoId, newAudio);
      _this.storage.setLastAudio(newAudio);
      _this.player.set('objectAudioId', newAudio);
    }
  }, 1000);
}

function onAudioTrackChange() {
  //do nothing, maybe need later
}

function onSubtitlesChange(event) {
  _this.storage.setSubtitles(event.data);
}

function onVolumeChange(event) {
  if (Number.isFinite(Number(event.data))) {
    _this.storage.setVolume(event.data);
  }
}

function onMutedChange(event) {
  if (!_this.player.get('player:silentMode')) {
    _this.storage.setMuted(event.data);
  }

  const videos = _this.player.get('videoInstances') || [];
  videos.forEach((v) => {
    if (v.muted !== event.data) {
      v.muted = event.data;
    }
  });
}

function onAdInternalEvent(event) {
  const value = event.name === 'ad:internal:mediaAdtBeginsLoading';
  _this.player.set('adtelligentMediaBeginLoad', value);
}

function onAdComplete(event) {
  if (event.data.type === 'preroll' && _this.espressoModeDetected) {
    _this.player.stop();
    _this.espressoModeDetected = false;
    _this.load(_this.config.videoURL);
  }

  const videoInstances = _this.player.get('videoInstances') || [];
  videoInstances.forEach((video) => {
    if (video.className.indexOf('ad:vendor:video') !== -1) {
      video.src = '';
    }
  });
}

function onChangeVideo(event) {
  if (
    _this.config.onSeriesChange &&
    typeof _this.config.onSeriesChange === 'function'
  ) {
    if (_this.config.onSeriesChange(event.data) === true) {
      return;
    }
  }

  if (_this.config.is_embed === true) {
    _this.getStream(
      `//embed.megogo.net/aprx/stream?video_id=${event.data}&lang=${_this.config.lang}&referer=${_this.config.href}`,
      _this.onVideoInfo
    );
  } else {
    _this.stop();
    _this.getStream(event.data, _this.onVideoInfo);
  }
}

function setVisibility(value) {
  if (_this.adSkinContainer) {
    _this.adSkinContainer.style.visibility = value;
  }
  if (_this.skinContainer) {
    _this.skinContainer.style.visibility = value;
  }
}

function onHideSkins() {
  setVisibility('hidden');
}

function onShowSkins() {
  setVisibility('visible');
}

function onAdBlockDetected() {
  _this.player.stop();
  const error = {
    name: _this.constructor.name,
    type: 'adBlock',
    code: 'adBlockDetected',
    message: _this.defaultErrorMessage,
    description: '',
    fatal: true,
  };

  setTimeout(() => {
    _this.onError(error);
  }, 300);
}

function onMediaError(event) {
  if (_this.player.get('adtelligentMediaBeginLoad')) {
    return;
  }

  let needRebinfo = true;
  const {
    userAgent: { os },
  } = _this.config;
  const videoInfo = _this.player.get('videoInfo') || {};

  if (os.name === 'Android' && Number(os.version) === 4) {
    // Android 4.4 : type and code is undefined in drm
    if (!event.data.type && !event.data.code && videoInfo.is_wvdrm) {
      needRebinfo = false;
      event.data.type = 'drmError';
      event.data.code = 'drmNotSupported';
    }
  }
  if (event.data.code === 'browserNotSupported') {
    needRebinfo = false;
  }

  if (event.data.fatal) {
    needRebinfo = true;

    if (!_this.contentBlockDetected) {
      utils.checkContentIsBlocked(_this.player, videoInfo.src, (data) => {
        if (!data || !onContentBlockDetected({ data: data })) {
          if (
            videoInfo &&
            videoInfo.video_id !== _this.player.get('videoInfo').video_id
          )
            return;

          if (
            !videoInfo.src ||
            videoInfo.src.length < 5 ||
            (videoInfo.is_wvdrm && event.name === 'mediaError') ||
            (needRebinfo && !_this.rebinfo(event))
          ) {
            _this.player.stop();

            if (videoInfo.content_type === 'tv_dvr_catchup') {
              _this.player.set(
                'interactiveChannel:currentPlayingProgram',
                null
              );
              _this.player.emit('dvrChannel:backOnAir', {
                autoplay: _this.player.get('state') !== 2,
              });
            } else {
              const error = event.data;
              if (error.type === 'DRM') {
                error.type = 'drmError';
                error.code = 'drmNotSupported';
              }
              error.stream = _this.stream;
              error.description = error.message;
              error.message = _this.defaultErrorMessage;
              _this.onError(error);
            }
          }
        }
      });
    }
  }
}

function onContentBlockDetected(event) {
  const error = event.data || {};
  if (error.status === 0) return false;

  _this.contentBlockDetected = true;
  _this.player.stop();

  error.type = 'playbackError';
  error.code = 'contentIsBlocked';
  error.fatal = true;

  error.stream = _this.stream;
  error.message = _this.defaultErrorMessage;

  if (!error.reason) {
    // если не доступны хедеры
    const videoInfo = _this.player.get('videoInfo') || {};
    utils.checkContentIsBlocked(_this.player, videoInfo.src, (data) => {
      if (data) utils.merge(data, error);
      _this.onError(error);
    });
  } else {
    _this.onError(error);
  }
  return true;
}

function checkWeboramaDPM() {
  if (!_this.config.lpdid) {
    new AdFoxLPD().getID((err, id) => {
      if (id) {
        _this.player.config.lpdid = id;
        _this.config.lpdid = id;
      }
    });
  }

  if (!Cookie.get('wdpm')) {
    _this.getDefaultLoader().load(
      '//wam.solution.weborama.fr/fcgi-bin/dispatch.fcgi?d.A=prd&d.key=n9d9C9I4XN1I&d.format=json&d.top_clusters=10',
      (data) => {
        try {
          const wdpm = JSON.parse(data);
          Cookie.set('wdpm', data, { expires: 1, samesite: 'lax' });
          _this.player.config.weboramaDPM = wdpm;
          _this.config.weboramaDPM = wdpm;
        } catch (e) {
          console.warn(e.message);
        }
      },
      Function.prototype,
      true
    );
  } else {
    const wdpm = JSON.parse(Cookie.get('wdpm'));
    _this.player.config.weboramaDPM = wdpm;
    _this.config.weboramaDPM = wdpm;
  }
}

function onAdGlobalTimeoutsChanged(event) {
  if (event.data) {
    try {
      window.localStorage.setItem(
        AD_GLOBAL_TIMEOUTS,
        JSON.stringify(event.data)
      );
    } catch (error) {
      console.error(error);
    }
  }
}

function onEPG2ChannelClick() {
  _this.player.stop();
}

export default {
  init,
  onPlayerReady,
  onMessageModeChanged,
  onPlayerStateChange,
  onPlayerComplete,
  onAutoplayChanged,
  onQualityChange,
  onAudioTrackChange,
  onAudioButtonClick,
  onSubtitlesChange,
  onVolumeChange,
  onMutedChange,
  onAdComplete,
  onChangeVideo,
  onHideSkins,
  onShowSkins,
  onAdBlockDetected,
  onMediaError,
  checkWeboramaDPM,
  onContentBlockDetected,
  onAdGlobalTimeoutsChanged,
  onAdInternalEvent,
  onEPG2ChannelClick,
};
